import { Box, Button, Divider, Fade, makeStyles, Paper, Popper, Typography, IconButton } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import clsx from "clsx";
import useDevice from "src/hooks/use-device";

import TextCopyButton from "src/components/TextCopyButton";
import { formatAddress, numberWithCommas } from "src/utils/format";
import travaLogo from "src/assets/icons/tokens/Trava.png";
import Wallet from "src/icons/Wallet";
import ExternalLink from "src/icons/ExternalLink";
import ViewAccountAddressOnBSC from "src/components/bsc-explorer/ViewAccountAddressOnBSC";
import { disconnectCurrentWallet } from "src/web3/wallet/event-handler/disconnect";
import useTravaBalance from "src/hooks/balance/use-trava-balance.js";
import { isNumeric } from "src/utils";

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    minWidth: 200,
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  imgCoin: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
  },
  button: {
    border: 0,
    textTransform: "capitalize",
    padding: theme.spacing(1.2, 1),
    minWidth: "163px",
    background: "linear-gradient(100.42deg, #2C85EE 16.07%, #4FB5FF 79.2%)",
  },
  fiberIcon: {
    fontSize: 10,
    verticalAlign: "middle",
    marginRight: 2,
    color: "#01C514",
  },
  balanceValue: {
    fontWeight: 500,
  },
  btn: {
    padding: theme.spacing(0),
    textTransform: "unset",
    fontWeight: 400,
    display: "flex",
    alignItems: "baseline",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
  btnBuyTrava: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buyTravaLink: {
    textDecoration: "none",
  },
}));

function AccountPopper(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const accountAddress = useSelector((state) => state.accountSlice.address);
  const classes = useStyles();
  const dp = useDispatch();
  const { enqueueSnackbar: eq } = useSnackbar();
  const { travaBalance } = useTravaBalance();
  const { headerDisplayFull } = useDevice();

  const open = Boolean(anchorEl);
  const id = open ? "account-popper" : undefined;

  useEffect(() => {
    window.addEventListener("click", handleWindowClick);
    return () => window.removeEventListener("click", handleWindowClick);
  }, []);

  function handleWindowClick() {
    setAnchorEl(null);
  }

  function handleClickBtn(ev) {
    ev.stopPropagation();
    setAnchorEl(anchorEl ? null : ev.currentTarget);
  }

  function handleDisconnectWallet() {
    disconnectCurrentWallet(dp, eq);
  }

  return (
    <Fragment>
      {!headerDisplayFull ? (
        <IconButton aria-describedby={id} size="small" onClick={handleClickBtn}>
          <Wallet size={20} />
        </IconButton>
      ) : (
        <Button
          aria-describedby={id}
          size="small"
          className={classes.button}
          variant="outlined"
          onClick={handleClickBtn}
        >
          <Box display="flex" alignItems="center">
            <Wallet size={22} />
            <Box pl={1.5} display="flex" alignItems="center">
              <span style={{ fontSize: 15, lineHeight: 0 }}>{formatAddress(accountAddress)}</span>
            </Box>
          </Box>
        </Button>
      )}

      <Popper id={id} open={open} anchorEl={anchorEl} transition placement="bottom-end" className={classes.popper}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={1} className={classes.paperRoot} onClick={(ev) => ev.stopPropagation()}>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">{formatAddress(accountAddress)}</Typography>
                <TextCopyButton text={accountAddress} tooltipTitle={"Copy account address"} />
                <ViewAccountAddressOnBSC address={accountAddress} />
              </Box>
              <Box display="flex" alignItems="center" pt={1} pb={2}>
                <Box className={classes.imgCoin} mr={1}>
                  <img width={25} src={travaLogo} alt="" />
                </Box>
                <Box>
                  <Typography variant="body2" color="textSecondary">
                    Balance
                  </Typography>
                  <Typography variant="body2" className={classes.balanceValue}>
                    {isNumeric(travaBalance) ? numberWithCommas(Number(parseFloat(travaBalance).toFixed(2))) : "---"}
                    &nbsp;TRAVA
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <Box pt={1}>
                <a
                  href="https://pancakeswap.finance/swap?outputCurrency=0x0391bE54E72F7e001f6BBc331777710b4f2999Ef"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.buyTravaLink}
                >
                  <Button className={clsx(classes.btn, classes.btnBuyTrava)}>
                    Buy TRAVA &nbsp; <ExternalLink size={15} />
                  </Button>
                </a>
              </Box>
              <Box>
                <Button className={classes.btn} onClick={handleDisconnectWallet}>
                  Disconnect
                </Button>
              </Box>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Fragment>
  );
}

export default AccountPopper;
